import { Product, RuntimeConfig, FeatureFlags } from "../../types/types";
import { useRouter } from "next/router";
import {
  isM2MRomanBlindOrCurtain,
  isMadeToMeasure,
} from "@/utils/product/isMadeToMeasure";
import { RomanBlindsForm } from "./components/RomanBlindsForm/RomanBlindsForm";
import { CurtainsForm } from "./components/CurtainsForm/CurtainsForm";
import { isInStoreOnly } from "@/utils/variant/isInStoreOnly";
import { useVariant } from "@/hooks/useVariant/useVariant";

type Props = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  flags: FeatureFlags;
};

export const MadeToMeasureForm = ({ product, runtimeConfig, flags }: Props) => {
  const router = useRouter();
  const { variant } = useVariant(product);

  if (!isMadeToMeasure(product) || isInStoreOnly(variant)) return null;

  if (isM2MRomanBlindOrCurtain(product)) {
    const FormComponent =
      router.query?.roman === "true" ? RomanBlindsForm : CurtainsForm;

    return (
      <div data-testid="m2m-form-container">
        <FormComponent
          product={product}
          runtimeConfig={runtimeConfig}
          flags={flags}
        />
      </div>
    );
  }

  return null;
};
